if (localStorage.discountCode) {
    applyDiscountCode(JSON.parse(localStorage.discountCode).code);
}

function clearDiscountBtn(e) {
    e.preventDefault();
    clearDiscount();
}

function applyDiscountBtn() {
    let discountCodeInput = document.querySelector("#discount-code-input");
    
    if (discountCodeInput.value !== '') {
        applyDiscountCode(discountCodeInput.value)
        discountCodeInput.style.border = 'unset'
    } else {
        discountCodeInput.style.border = '1px solid red'
    }
}

function clearDiscount() {
    let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
    let discountCodeError = document.querySelector("#discount-code-error");

    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    fetch("/checkout?discount=%20");
}
function clearLocalStorage() {
    let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
    let totalCartSelector = document.querySelector(".cart__subtotal .money"); // Total Cart Selector to update the total amount.

    if (discountCodeWrapper) {
        discountCodeWrapper.style.display = "none";
    }

    if (totalCartSelector) {
        totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
    }

    localStorage.removeItem("discountCode");
}
function applyDiscountCode(code) {
    let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
    let discountCodeError = document.querySelector("#discount-code-error");
    let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
    let totalCartSelector = document.querySelector(".cart__subtotal .money"); // Total Cart Selector to update the total amount.

    let applyBtn = document.querySelector("#apply-discount-btn");
    applyBtn.innerHTML = "APPLYING... <div class='loader'></div>";
    applyBtn.style.pointerEvents = "none";

    try {
    // Code that might throw an error
    fetch(`/discount/${code}`).then(() => {
        fetch('/cart?view=discount', {}).then(function (res) { return res.text(); })
            .then(function (data) {
                let dataObject = JSON.parse(JSON.stringify(data))
                dataObject = JSON.parse(dataObject)

                const appliedCodes = data.discounts.map(i => i.title.trim().toLowerCase());

                if (appliedCodes.includes(code.trim().toLowerCase())) {
                    if (discountCodeWrapper) {
                        discountCodeWrapper.style.display = "inline-flex";
                    }

                    if (discountCodeError) {
                        discountCodeError.innerHTML = "";
                    }

                    if (discountCodeValue) {
                        discountCodeValue.innerHTML = dataObject.discounts[0].title + " (" + dataObject.discounts[0].amount + ")";
                    }

                    let localStorageValue = {
                        'code': code.trim(),
                        'totalCart': dataObject.total_price_with_currency
                    };

                    localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
                    
                    if (totalCartSelector) {
                        totalCartSelector.innerHTML = dataObject.total_price;
                    }
                } else {
                    if (discountCodeValue) {
                        discountCodeValue.innerHTML = "";
                    }

                    clearLocalStorage();
                    
                    if (discountCodeError) {
                        discountCodeError.innerHTML = "Please Enter Valid Coupon Code!";
                    }
                }
            })
            .finally(function () {
                if (applyBtn) {
                    applyBtn.innerHTML = "APPLY";
                    applyBtn.style.pointerEvents = "all";
                }
            });
    })
        } catch (error) {
    console.log(error);
        }
}